module.exports = __webpack_public_path__ + "img/6169a4c.jpg";